<!-- HEADER -->
<header id="header" class="combo01">
  <div id="header-inner">
      <img class="blob-blue-bg mobile" src="assets/img/header/header_mobile_blob_blue.svg" />
      <img class="blob-blue-bg desktop" src="assets/img/header/header_blob_blue.svg" />

      <div class="container">
          <div class="row">
              <div class="col col-6-md offset-md-1 col-left">
                <h1 class="page-title" [innerHtml]="pageTitle">
                </h1>

                <p class="page-description">
                  <span *ngFor="let line of pageDescription">{{ line }}</span>
                </p>
              </div>
          </div>
      </div>

      <img class="page-header" src="assets/img/pages/page_header_bg.svg" />
  </div>

  <img class="blob-orange" [class.extra-space]="pageDescription.length > 2" src="assets/img/blobs/pages/blob_orange.svg" />
  <img class="blob-green" src="assets/img/blobs/pages/blob_green.svg" />
  <img class="blob-purple" src="assets/img/blobs/pages/blob_purple.svg" />
  <img class="blob-blue" src="assets/img/blobs/pages/blob_blue.svg" />

  <img class="blob-white blob-white-1" src="assets/img/blobs/blob_white.svg" />
  <img class="blob-white blob-white-2" src="assets/img/blobs/blob_white.svg" />
  <img class="blob-white blob-white-3" src="assets/img/blobs/blob_white.svg" />
  <img class="blob-white blob-white-4" src="assets/img/blobs/blob_white.svg" />
  <img class="blob-white blob-white-5" src="assets/img/blobs/blob_white.svg" />
</header>

<!-- HEADER image -->
<div id="header-image">
      <img src="{{ imageURL }}" />
  </div>
<!-- end HEADER image -->